export default function Loader({ full = false, label = 'Loading' }) {
  return (
    <div className={full ? 'loader loader-full' : 'loader'} role="status" aria-live="polite">
      <span className="loader-dot" />
      <span className="loader-dot" />
      <span className="loader-dot" />
      <span className="sr-only">{label}</span>
    </div>
  );
}
